// extracted by mini-css-extract-plugin
export default {"header":"remove_header__5avgI","info":"remove_info__h6ogH","btnContainer":"remove_btnContainer__ZShSq","cancel":"remove_cancel__XP7Dc","confirm":"remove_confirm__CniUe"};